import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Enquiry from "@/pages/Enquiry";
import Admin from "@/pages/Admin";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";

function ScrollManager() {
    const { pathname } = useLocation();
    useEffect(() => {
        // Only scroll to top on page navigation (not on hash-based)
        if (!window.location.hash) {
            window.scrollTo({ top: 0, left: 0, behavior: "instant" });
        }
    }, [pathname]);
    return null;
}

function Shell() {
    const { pathname } = useLocation();
    const hideChrome = pathname.startsWith("/admin");
    return (
        <>
            {!hideChrome && <Navbar />}
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/about" element={<About />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/enquiry" element={<Enquiry />} />
                <Route path="/admin" element={<Admin />} />
            </Routes>
            {!hideChrome && <Footer />}
        </>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ScrollManager />
                <Shell />
                <Toaster
                    position="bottom-center"
                    toastOptions={{
                        style: {
                            background: "#1B4332",
                            color: "#FAF9F6",
                            border: "1px solid rgba(250,249,246,0.18)",
                            borderRadius: 0,
                            fontFamily: "Outfit, sans-serif",
                            fontSize: 13,
                            letterSpacing: "0.06em",
                        },
                    }}
                />
            </BrowserRouter>
        </div>
    );
}

export default App;
